// Types
import { useCallback } from "react";
import { TUseMemberCard } from "../Team.types";

const useMemberCard: TUseMemberCard = (
    restoreIconRef,
    member,
    setPersonInfo,
    setToggleShowWorkHistory,
    setAnchorEl,
    parentRef,
    type
) => {
    const onClickRestoreIcon = useCallback(
        (event: React.MouseEvent<HTMLElement>) => {
            setToggleShowWorkHistory &&
                setToggleShowWorkHistory((currentState) => {
                    const initialPersonInfo = {
                        role: "",
                        id: -1,
                        info: undefined,
                    };
                    const newPersonInfo = {
                        role: member.role ? member.role : "",
                        id: member.person_id,
                    };

                    setPersonInfo && setPersonInfo(currentState ? initialPersonInfo : newPersonInfo);

                    return !currentState;
                });
            if (setAnchorEl) {
                setAnchorEl(event.currentTarget);
            }
        },
        [member, setAnchorEl, setPersonInfo, setToggleShowWorkHistory]
    );

    return onClickRestoreIcon;
};

export default useMemberCard;
